import { GoogleMap, Marker, useLoadScript } from '@react-google-maps/api';
import { useEffect, useState } from 'react';
import styles from './index.module.scss';
// 组件
import UKLoadingIcon, { CIRCLE_COLOR_MAP } from '@/components/UKLoadingIcon';
// 图标
import ActiveLocationIco from '../../assets/activeLocationIco.png';
import DefaultLocationIco from '../../assets/defaultLocationIco.png';

// 接口
import { PostHouseListResVo } from '@/apis/afterSales/afterSales.interface';
interface GoogleMapsType {
  updateLocation?: (location: any) => void;
  locationList: PostHouseListResVo[];
  curLocationInfo?: PostHouseListResVo | null;
}
const GoogleMaps = ({ updateLocation, locationList, curLocationInfo }: GoogleMapsType) => {
  const [currentLocation, setCurrentLocation] = useState({});
  const apiKey = process.env.NEXT_PUBLIC_GOOGLE_MAP_API_KEY as string;

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: apiKey,
  });
  // useEffect(() => {
  //   setCurrentLocation({
  //     lat: Number(curLocationInfo?.latitude),
  //     lng: Number(curLocationInfo?.longitude),
  //   });
  // }, [curLocationInfo]);

  useEffect(() => {
    if (curLocationInfo) {
      setCurrentLocation({
        lat: Number(curLocationInfo?.latitude),
        lng: Number(curLocationInfo?.longitude),
      });
    } else if (locationList[0]) {
      setCurrentLocation({
        lat: Number(locationList[0]?.latitude),
        lng: Number(locationList[0]?.longitude),
      });
    }
  }, [locationList, curLocationInfo]);

  const LoadingComponent = () => (
    <div className={styles.mapLoading}>
      <UKLoadingIcon type={CIRCLE_COLOR_MAP.BLACK} />
    </div>
  );

  // 处理Marker点击
  const handleMarkerClick = (clickedPosition: any) => {
    setCurrentLocation({
      lat: Number(clickedPosition.latitude),
      lng: Number(clickedPosition.longitude),
    });
    updateLocation && updateLocation(clickedPosition);
    // setSelectedPosition(clickedPosition);
  };

  return (
    <div className={styles.container}>
      <div className={styles.maps}>
        {isLoaded ? (
          <GoogleMap
            mapContainerStyle={{ height: '291px', width: '100%', borderRadius: '6px' }}
            center={currentLocation as any}
            zoom={16}
            options={{
              mapTypeId: 'roadmap',
              disableDefaultUI: true, // 禁用默认控件
            }}
          >
            {locationList?.map((marker) => (
              <Marker
                key={marker.postCode}
                position={{ lat: Number(marker.latitude), lng: Number(marker.longitude) }}
                icon={
                  curLocationInfo?.postHouseId === marker?.postHouseId
                    ? {
                        url: ActiveLocationIco.src,
                        scaledSize: new window.google.maps.Size(34, 42),
                      }
                    : {
                        url: DefaultLocationIco.src,
                        scaledSize: new window.google.maps.Size(24, 28.8),
                      }
                }
                onClick={() => {
                  handleMarkerClick(marker);
                }} // 绑定点击事件
              />
            ))}
            {/* 当前定位点 */}
            {/* {curLocationInfo ? (
              <Marker
                position={{ lat: Number(curLocationInfo.latitude), lng: Number(curLocationInfo.longitude) }}
                icon={{ url: CurLocationIco.src, scaledSize: new window.google.maps.Size(24, 24) }}
              />
            ) : null} */}
          </GoogleMap>
        ) : (
          LoadingComponent()
        )}
        {/* </LoadScript> */}
      </div>
    </div>
  );
};

export default GoogleMaps;
